import { FC, useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import * as ST from './styled'

const modal: HTMLDivElement = document.getElementById('modal') as HTMLDivElement

type ModalProps = {
  marker: string
  children: JSX.Element
  open: boolean
  isFixed?: boolean
  zIndex?: number
}

const Modal: FC<ModalProps> = ({ marker, children, open, isFixed, zIndex }) => {
  const [display, setDisplay] = useState<boolean>(false)
  const elementMemo = useMemo(() => {
    const element: HTMLDivElement = document.createElement('div')
    element.dataset.marker = marker
    return element
  }, [marker])

  useEffect(() => {
    modal.appendChild(elementMemo)
  })

  useEffect(() => {
    setDisplay(open)
    if (open) document.body.style.overflowY = 'hidden'

    return () => {
      document.body.removeAttribute('style')
    }
  }, [open])

  const wrapperWindow = (
    <ST.WrapperWindow
      isFixed={isFixed}
      displayState={display}
      open={open}
      zIndex={zIndex}
    >
      {children}
    </ST.WrapperWindow>
  )

  return createPortal(wrapperWindow, elementMemo)
}

export default Modal;
